import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['field']

  toggle(event) {
    if (!this.hasFieldTarget) return;

    const toggled = event.currentTarget.checked;
    this.fieldTarget.disabled = toggled;
    this.fieldTarget.required = !toggled;

    if (toggled) {
      this.fieldTarget.value = '';
    }
  }
}
